import React from 'react';
import { StudentTable } from './StudentTable';

export function ChildProfiles() {
  return (
    <div className="space-y-4">
      <StudentTable />
    </div>
  );
}